const SuspendOrArchieveEnum = {
  SUSPEND: 0,
  ARCHIVE: 1,
}

export default SuspendOrArchieveEnum;
